<nz-radio-group
  [formControl]="formControl"
  [formlyAttributes]="field"
  [nzSize]="props.size"
  (ngModelChange)="props.change && props.change(field, $event)">
  @for (
    option of props.options | formlySelectOptions: field | async;
    track option.value
  ) {
    @if (props.type === 'radio') {
      <label
        nz-radio
        [nzValue]="option.value"
        [nzDisabled]="option.disabled">
        {{ option.label }}
      </label>
    } @else {
      <label
        nz-radio-button
        [nzValue]="option.value"
        [nzDisabled]="option.disabled">
        {{ option.label }}
      </label>
    }
  }
</nz-radio-group>
